import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateDirective } from '@ngx-translate/core';
import { AutofocusDirective } from '../autofocus/autofocus.directive';

@Component({
  selector: 'app-confirm-upload-dialog',
  templateUrl: './confirm-upload-dialog.component.html',
  imports: [TranslateDirective, AutofocusDirective],
})
export class ConfirmUploadDialogComponent {
  protected modal = inject(NgbActiveModal);
}
